import { render, staticRenderFns } from "./MovementEventsLog.vue?vue&type=template&id=9f89b574&scoped=true"
import script from "./MovementEventsLog.vue?vue&type=script&lang=ts"
export * from "./MovementEventsLog.vue?vue&type=script&lang=ts"
import style0 from "./MovementEventsLog.vue?vue&type=style&index=0&id=9f89b574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f89b574",
  null
  
)

export default component.exports